import { React, useEffect, useState } from "react";
import axios from "axios";
import { FxmsData } from "../datas/FxData";
import Button from '@mui/material/Button';
import { TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import './LinkAdmin.css';

const LinkAdmin = (props) => {
  const { userGrpNo } = props;
  let [menuList, setMenuList] = useState([]);
  let [DashList, setDashList] = useState([]);
  let [LinkList, setLinkList] = useState([]);
  let [selectMenu, setSelectMenu] = useState({});
  let [selectDash, setSelectDash] = useState({});
  const [linkSaveCount, setLinkSaveCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [linkData, setLinkData] = useState({});

  useEffect(()=> {

    // 링크로 연결시킬 메뉴 리스트들을 가져옴
    async function getMenuList() {
      const uri = "fxUiDash/dash/getMenuList/" + userGrpNo;
      const res = await FxmsData.GET(uri);
      setMenuList(res.data);

    }

    // 이미 링크로 연결되어 있는 메뉴들을 가져옴
    async function getLinkList() {
      const uri = "fxUiDash/dash/getLinkList/" + userGrpNo;
      const res = await FxmsData.GET(uri);
      setLinkList(res.data);
    }

    // 사용 가능한 대시보드 목록들을 가져옴
    async function getDashBoard() {
      const uri = "fxUiDash/dash/userGrpNo/" + userGrpNo;
      const res = await FxmsData.GET(uri);
      setDashList(res.data);
    }

    getMenuList();
    getDashBoard();
    getLinkList();

  }, [linkSaveCount]);


  const selectedMenu = (data) => {
    setSelectMenu(data);
  }

  const selectedDash = (data) => {
    setSelectDash(data);
  }

  const linkSave = async () => {
    if (selectMenu.opId == undefined) {
      alert("메뉴를 선택해주세요");
    } else if (selectDash.dashbNo == undefined) {
      alert("대시보드를 선택해주세요");
    } else {
      try {
        const uri = "fxUiDash/dash/link";
        const para = [{
          opId: `${selectMenu.opId}`,
          dashbNo: selectDash.dashbNo
        }];
        const res = await FxmsData.PUT(uri, para);
        console.log(res);

        // 비동기 처리가 완료되었을 때 linkSaveCount 상태를 갱신
        setLinkSaveCount(prevCount => prevCount + 1);
      } catch (error) {
        // 오류 처리
        console.error(error);
      }
    }
  };

  const deleteMenuInput = () => {
    setSelectMenu({opTitle: ""});
  }

  const deleteDashInput = () => {
    setSelectDash({dashbName: ""});
  }

  const openDialog = (data) => {
    //console.log("deleteLink " + data.opId + " :: " + data.dashbNo);
    setLinkData(data);
    setDialogOpen(true);
  }

  const cancelDelete = () => {
    setDialogOpen(false);
  }

  const deleteLink = async () => {
    //console.log("linkData : " + JSON.stringify(linkData));
    const uri = "fxUiDash/dash/deleteLink"
    const para = {
      opId: `${linkData.opId}`,
      dashbNo: `${linkData.dashbNo}`
    }
    const res = await FxmsData.PUT(uri, para);
    console.log(res);
    setDialogOpen(false);
    setLinkSaveCount(prevCount => prevCount + 1);
  }


  return (
    <>
    <div id="LinkAdmin">
      <div className="LinkBoard">
        <div className="menuList">
          <div className="ListHeader">메뉴 목록</div>
          {menuList.map((data)=>{return <div key={data.opId} onClick={() => selectedMenu(data)}>
            <span className="menuCell">{data.opTitle}</span>
          </div>})}
        </div>
        <div className="Input">
          <div className="InputMenu">
            <TextField variant="outlined" value={selectMenu.opTitle} onClick={deleteMenuInput} sx={{ input: { color: 'white', textAlign: "center", cursor: "pointer" }, }} InputProps={{ readOnly: true, }}/>
          </div>
          <span> ⇔ </span>
          <div className="InputDash">
            <TextField variant="outlined" value={selectDash.dashbName} onClick={deleteDashInput} sx={{ input: { color: 'white', textAlign: "center", cursor: "pointer" }, }}  InputProps={{ readOnly: true, }}/>
          </div>
        </div>
        <div className="dashBoardList">
          <div className="ListHeader">대시보드 목록</div>
          {DashList.map((data)=>{return <div key={data.dashbNo} onClick={() => selectedDash(data)}>
            <span className="menuCell">{data.dashbName}</span>
          </div>})}
        </div>
        <div className="Arrow"> ≫ </div>
        <div className="LinkList">
          <div className="ListHeader">링크 연결 완료</div>
          {LinkList.map((data)=>{return <div key={data.opId}>
            <span className="linkCell" onClick={() => openDialog(data)}>[ {data.opTitle} ] <span style={{color: "#00d1ff"}}>↔</span> [ {data.dashbName} ] 링크</span>
          </div>})}
        </div>
      </div>
      <div className="LinkSaveBtn">
        <Button variant="contained" color="primary" onClick={linkSave} size="large">링크저장</Button>
      </div>
    </div>
    <Dialog
      open={dialogOpen}
      onClose={()=>setDialogOpen(false)}
    >
    <DialogTitle>
      링크를 삭제하시겠습니까?
    </DialogTitle>
    <DialogContent>
      <div className="dialogGroup">
        <Button variant="contained" color="primary" className="dialogBtn" onClick={cancelDelete} sx={{float: "right", margin: "5px"}}>
          취소
        </Button>
        <Button variant="contained" color="primary" className="dialogBtn" onClick={()=>deleteLink(selectMenu, selectDash)} sx={{float: "right", margin: "5px"}}>
          삭제
        </Button>
      </div>
    </DialogContent>
    </Dialog>
    </>
  );
}

export default LinkAdmin;